import { render, staticRenderFns } from "./SubdomainsView.vue?vue&type=template&id=5058d49c&"
import script from "./SubdomainsView.vue?vue&type=script&lang=js&"
export * from "./SubdomainsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5058d49c')) {
      api.createRecord('5058d49c', component.options)
    } else {
      api.reload('5058d49c', component.options)
    }
    module.hot.accept("./SubdomainsView.vue?vue&type=template&id=5058d49c&", function () {
      api.rerender('5058d49c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/shared/domains/SubdomainsView.vue"
export default component.exports